import * as React from "react";
// UI Framework
import { Layout } from "antd";
// Utilities
import { Switch } from "react-router";
import { isMobile } from "react-device-detect";
//Shared components
import Enamad from "components/Enamad";
import PageTitle from "components/PageTitle";
import PrivateRoute from "components/PrivateRoute";
// Local components
import Deposit from "./screens/Deposit";
import Profile from "./screens/Profile";
import Starter from "./screens/Starter";
import Reports from "./screens/Reports";
import Sell from "./screens/Sell";
import Sider from "./components/Sider";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Issue from "./screens/Issue";
import Settlements from "./screens/Settlements";
import Financials from "./screens/Financials";
import ChangePassword from "./screens/Password";
import PhysicalGold from "./screens/PhysicalGold";
import BankAccounts from "./screens/BankAccounts";
import Tickets from "./screens/Tickets";
import ShowTicket from "./screens/Tickets/components/tickets/ShowTicket";
// Styles
import styles from "./index.module.scss";

interface IState {
	collapsed: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAction extends Partial<IState> {}

function reducer(state: IState, action: IAction): IState {
	return { ...state, ...action };
}

const Dashboard: React.FC = () => {
	const { Content: LayoutContent } = Layout;
	const initialState = () => ({ collapsed: false } as IState);
	const [store, dispatch] = React.useReducer(reducer, initialState());

	function handleCollapse(collapsed: boolean): void {
		dispatch({ collapsed });
	}

	return (
		<Layout>
			<PageTitle title="صفحه اصلی داشبورد" />
			<Sider collapsed={store.collapsed} onCollapse={handleCollapse} />
			<Layout style={{ minHeight: "100vh" }}>
				<Header />
				<LayoutContent
					className={styles["dashboard-content"]}
					onClick={() => {
						if (isMobile) {
							dispatch({ collapsed: false });
						}
					}}
				>
					<Switch>
						<PrivateRoute path="/dashboard/deposit" component={Deposit} />
						<PrivateRoute path="/dashboard/profile" component={Profile} />
						<PrivateRoute path="/dashboard/change-password" component={ChangePassword} />
						<PrivateRoute exact path="/dashboard/" component={Starter} />
						<PrivateRoute path="/dashboard/sell" component={Sell} />
						<PrivateRoute path="/dashboard/reports" component={Reports} />
						<PrivateRoute path="/dashboard/issue" component={Issue} />
						<PrivateRoute path="/dashboard/financials" component={Financials} />
						<PrivateRoute path="/dashboard/settlements" component={Settlements} />
						<PrivateRoute path="/dashboard/physical/gold" component={PhysicalGold} />
						<PrivateRoute path="/dashboard/bank/accounts" component={BankAccounts} />
						<PrivateRoute exact path="/dashboard/tickets" component={Tickets} />
						<PrivateRoute path="/dashboard/tickets/:id" component={ShowTicket} />
					</Switch>
				</LayoutContent>
				<Enamad style={{ position: "fixed", bottom: 10, left: 0 }} />
				<Footer />
			</Layout>
		</Layout>
	);
};

export default Dashboard;
